import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage

import { SET_MAP_TRAILS_VISIBLE } from './actions';

const persistConfig = {
    key: 'data/preferences',
    storage,
}

const initialState = {
    mapTrailsVisible: true,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_MAP_TRAILS_VISIBLE: {
            return {
                ...state,
                mapTrailsVisible: action.payload
            };
        }
        default:
            return state;
    }
};

export default persistReducer(persistConfig, reducer);
